var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoForHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 573,
    height: 456,
    viewBox: "0 0 573 456",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.61 427.31C137.61 443.37 126.18 451.67 116.4 453.9C106.61 456.13 92.71 453.6 85.76 439.12L15.44 292.8C-4.48 251.34 -4.48 203.78 15.44 162.31L85.76 15.99C91.3 4.45 101.25 0.5 110.02 0.5C112.25 0.5 114.41 0.76 116.39 1.21C126.18 3.44 137.61 11.74 137.61 27.8V427.31Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeWidth: "10px",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.32 392.16C316.32 403.62 309.49 414.18 298.79 418.3C288.8 422.14 277.91 419.95 270.14 412.47L177.59 323.36C151.31 298.06 136.83 264.03 136.83 227.55C136.83 191.07 151.31 157.05 177.59 131.75L270.14 42.6399C275.38 37.5899 282.05 34.95 288.91 34.95C292.27 34.95 295.68 35.5899 298.99 36.8899C309.58 41.0499 316.32 51.55 316.32 62.93V392.16Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeWidth: "10px",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.09 325.8C438.09 334.89 433.81 343.06 426.34 348.23C418.87 353.4 409.71 354.53 401.21 351.33C348.37 331.44 315.55 284.01 315.55 227.56C315.55 171.11 348.37 123.67 401.21 103.78C404.4 102.59 407.67 102 410.91 102C416.01 102 421.04 103.46 425.51 106.33C433.48 111.44 438.09 120.46 438.09 129.93V325.8Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeWidth: "10px",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.65 307.02C469.51 299.06 448.84 261.45 448.84 227.56C448.84 193.67 469.51 156.05 515.65 148.09V307.02Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeWidth: "10px",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 572.97,
    height: 455.11,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoForHeader);
export default __webpack_public_path__ + "static/media/logo-for-header.9a7e263332eac2c6328069a1a385a71c.svg";
export { ForwardRef as ReactComponent };